import cleanedUpArray from "../../colorMap";

// function to transform hex color code to bosch color
export const hexToBosch = (colorToClean) => cleanedUpArray
  .filter((swatch) => swatch.color === colorToClean)
  .map((filteredSwatch) => filteredSwatch.name.replace("--bosch-", ""));